<template>
  <div>
    <div class="box-form-result">
      <b-form-group label="" label-for="keyword" class="border-bottom-form">
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <b-form-input
              v-model="searchForm.keyword"
              id="keyword"
              type="text"
              required
              placeholder="Nhập từ khóa tìm kiếm"
              @keyup="layDanhSachCanBoPhanTrang(true)"
              @blur="layDanhSachCanBoPhanTrang(true)"
              @keyup.enter="layDanhSachCanBoPhanTrang(true)"
            />
          </div>
          <div class="col-md-4 col-xs-12">
            <v-select
              :options="danhSachDonViSelect"
              :reduce="(text) => text.value"
              label="text"
              v-model="searchForm.donVi"
              @input="layDanhSachCanBoPhanTrang(true)"
              v-if="!idDonViCha"
            >
            </v-select>
            <treeselect
              v-else
              :load-options="loadOptionsDonVi"
              :clearable="true"
              :normalizer="normalizer"
              :options="optionsDonVi"
              :show-count="true"
              :value="searchForm.donVi"
              no-children-text="Không có đơn vị con"
              placeholder="Chọn đơn vị"
              ref="chonCayDonVi"
              v-model="searchForm.donVi"
              @input="layDanhSachCanBoPhanTrang(true)"
            >
              <label
                :class="labelClassName"
                slot="option-label"
                slot-scope="{
                  node,
                  shouldShowCount,
                  count,
                  labelClassName,
                  countClassName,
                }"
              >
                {{ node.label }}
                <span :class="countClassName" v-if="shouldShowCount && count > 0"
                  >({{ count }})</span
                >
              </label>
            </treeselect>
          </div>
          <div class="col-md-4 col-xs-12">
            <b-button
              :disabled="danhSachIdCanBoDaChon.length === 0"
              class="btn search-information-btn d-block float-right mb-3 mr-2"
              @click="themDanhSachQuyenDaChon()"
            >
              Thêm {{ danhSachIdCanBoDaChon.length > 0 ? ` + ` + danhSachIdCanBoDaChon.length : ''}}
            </b-button>
          </div>
        </div>
      </b-form-group>
      <b-table
        v-if="hasPageData"
        striped
        bordered
        responsive
        :no-local-sorting="true"
        :items="danhSachCanBoThemVaoNguoiDung"
        :fields="fieldName"
        :busy="isLoadingTable"
      >
        <template v-slot:head()="scope">
          <div class="d-inline-block">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:head(checkbox)="">
          <b-form-checkbox
            id="check-all-items-in-system"
            name="checkbox_all_items_in_system"
            :value="true"
            :unchecked-value="false"
            v-model="selectAllRowsInPage"
          />
        </template>
        <template v-slot:cell(checkbox)="row">
          <b-form-checkbox
            v-model="danhSachIdCanBoDaChon"
            :value="row.item.id"
            name="selected-rows"
          >
          </b-form-checkbox>
        </template>
        <template v-slot:cell(thaoTac)="row">
          <b-icon
            title="Thêm quyền vào người dùng"
            icon="plus-circle-fill"
            :style="{
              color: '#2A6EBB',
              cursor: 'pointer',
              marginLeft: '10px',
            }"
            @click="themTungQuyen(row.item.id)"
          />
        </template>
        <template v-slot:table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{
              width: ['stt', 'checkbox',].includes(field.key) ? '50px' : '',
            }"
          />
        </template>
        <template v-slot:table-busy>
          <BaseLoadingTable />
        </template>
      </b-table>
      <BaseEmptyTable :header-table="emptyHeaderTable" v-else />
      <BasePagination
        :current-page="danhSachCanBo.pageIndex"
        :total-pages="danhSachCanBo.totalPage"
        :total-rows="danhSachCanBo.totalCount"
        @changeNum="onChangeNum($event)"
        @changePages="onChangePages($event)"
      />
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import { BANG_THEM_CAN_BO_VAO_NGUOI_DUNG } from "@/constants/constants";
import BaseLoadingTable from "@/components/common/BaseLoadingTable";
import BaseEmptyTable from "@/components/common/BaseEmptyTable";
import _isNil from "lodash/isNil";
import { THEM_CAN_BO_VAO_NGUOI_DUNG } from "@/constants/message";
import { LOAD_CHILDREN_OPTIONS, Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "DanhSachCanBoThemVaoNguoiDung",
  components: {
    BasePagination,
    BaseLoadingTable,
    BaseEmptyTable,
    Treeselect
  },
  data() {
    return {
      idDonViCha: "1",
      searchForm: {
        keyword: "",
        donVi: this.idDonViCha || 1
      },
      optionsDonVi: [],
      danhSachQuyenTrongNguoiDung: [],
      danhSachCanBoThemVaoNguoiDung: [],
      isLoadingTable: false,
      allPermissions: false,
      deletePermissionIds: [],
      NguoiDungId: null,
      danhSachIdCanBoDaChon: [],
      danhSachIdQuyen: [],
      selectAllRowsInPage: false,
      requestInformation: {
        sortBy: "",
        sortType: "",
        pageSize: 10,
        pageIndex: 1
      },
      emptyHeaderTable: [
        BANG_THEM_CAN_BO_VAO_NGUOI_DUNG.stt,
        BANG_THEM_CAN_BO_VAO_NGUOI_DUNG.hoTen,
        BANG_THEM_CAN_BO_VAO_NGUOI_DUNG.userName,
        BANG_THEM_CAN_BO_VAO_NGUOI_DUNG.thaoTac
      ]
    };
  },
  props: {
    // chiTietNguoiDung: {
    //   type: Object,
    //   required: true
    // },
  
  },
  created() {
    this.NguoiDungId = this.$router.currentRoute.params.id;
    this.layDanhSachTheoDonViCha();
    this.layDanhSachCanBoPhanTrang();
  },
  computed: {
    ...mapGetters({
      danhSachDonViSelect: "donVi/danhSachDonViSelect",
      danhSachCanBo: "canBo/danhSachCanBo",
    }),
    fieldName() {
      return this.getFieldName();
    },
    hasPageData() {
      return !_isEmpty(this.danhSachCanBo.items);
    },
  },
  watch: {
    "searchForm.keyword": {
      handler(val) {
        if (!val) {
          this.layDanhSachCanBoPhanTrang(true);
        }
      }
    },
    danhSachCanBo: {
      handler() {
        this.danhSachCanBoThemVaoNguoiDung = this.layDanhSachCanBoThemVaoNguoiDung(
          this.danhSachCanBo
        );
        this.danhSachIdQuyen = this.layDanhSachIdCanBo(this.danhSachCanBoThemVaoNguoiDung);
        this.clickSelectAllRowInPage();
      },
      immediate: true
    },
    selectAllRowsInPage: {
      handler() {
        this.clickSelectAllRowInPage();
      }
    }
  },
  methods: {
    layDanhSachCanBoPhanTrang(resetPage = false) {
      if (resetPage) this.danhSachCanBo.pageIndex = 1;
      let payload = {
        PageIndex: this.danhSachCanBo.pageIndex,
        PageSize: this.danhSachCanBo.pageSize
      };

      if (this.searchForm.keyword) {
        payload = Object.assign(payload, { FilterBy: this.searchForm.keyword });
      }
      if (this.searchForm.donVi) {
        payload = Object.assign(payload, { ID_DonVi: this.searchForm.donVi });
      }
      this.$store.dispatch("canBo/layDanhSachCanBo", payload);
    },
    onChangeNum(pageSize) {
      this.danhSachCanBo.pageIndex = 1;
      this.danhSachCanBo.pageSize = pageSize;
      this.layDanhSachCanBoPhanTrang();
    },
    async onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.danhSachCanBo.pageIndex = page;
      await this.layDanhSachCanBoPhanTrang();
      
    },
    loadOptionsDonVi({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        this.layDanhSachTheoDonViCha(parentNode.id).then(data => {
          parentNode.children = data;
          callback();
          this.$refs.chonCayDonVi.initialize(this.optionsDonVi);
        });
      }
    },
    layDanhSachTheoDonViCha(parentId = null) {
      return this.$store
        .dispatch("donVi/layDanhSachTheoDonViCha", {
          idDonViCha: parentId || this.idDonViCha,
          soCap: 999
        })
        .then(response => {
          if (!parentId && this.idDonViCha)
            this.$store.dispatch("donVi/layChiTietDonVi", {
              data: {
                id: this.idDonViCha
              },
              onSuccess: dataResponse => {
                this.optionsDonVi = [
                  {
                    id: this.idDonViCha,
                    tenDonVi: dataResponse.tenDonVi,
                    children: response
                  }
                ];
              }
            });
          else return response;
        });
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.tenDonVi,
        children: node.children || null
      };
    },

    layDanhSachIdCanBo(danhSachCanBo) {
      if (_isEmpty(danhSachCanBo)) {
        return [];
      }
      console.log('layDanhSachIdCanBo');
      return danhSachCanBo && danhSachCanBo.map(item => item.id);
    },


    themDanhSachQuyenDaChon() {
      this.permissionIds = this.danhSachIdCanBoDaChon;
      this.themQuyenVaoNguoiDung();
    },
    themTungQuyen(id) {
      this.permissionIds = [id];
      this.themQuyenVaoNguoiDung();
    },
    themQuyenVaoNguoiDungThanhCong() {
      this.$bvModal.hide("them-quyen-trong-nguoi-dung");
      this.layDanhSachQuyenTrongHeThong();
    },
    clickSelectAllRowInPage() {
      if (this.selectAllRowsInPage) {
        this.$set(
          this,
          "danhSachIdCanBoDaChon",
          this.danhSachIdCanBoDaChon.concat(this.danhSachIdQuyen)
        );
        this.$set(this, "danhSachIdCanBoDaChon", [
          ...new Set(this.danhSachIdCanBoDaChon)
        ]);
      } else {
        this.danhSachIdCanBoDaChon = this.danhSachIdCanBoDaChon.filter(
          id => !this.danhSachIdQuyen.includes(id)
        );
      }
      console.log("danhSachIdCanBoDaChon", this.danhSachIdCanBoDaChon);
    },
    themQuyenVaoNguoiDung() {
      const $vm = this;
      $vm.$store
        .dispatch("canBo/themCanBoVaoNguoiDung", {
          ids: this.permissionIds
        })
        .then(() => {
          $vm.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: THEM_CAN_BO_VAO_NGUOI_DUNG
          });
          $vm.$emit("themCanBoVaoNguoiDungThanhCong");
        })
        .catch(error => {
          $vm.$toasted.clear();
          if (
            !_isEmpty(error.response) &&
            error.response.data.Errors.length > 0
          ) {
            $vm.$toasted.global.showErrorMessage({
              message: error.response.data.Errors[0].Description
            });
          }
        });
    },
    layDanhSachQuyenTrongHeThong() {
      this.isLoadingTable = true;
      this.$store
        .dispatch("user/layDanhSachQuyenKhongThuocNguoiDung", {
          id: this.NguoiDungId
        })
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    getFieldName() {
      if (_isEmpty(this.danhSachCanBoThemVaoNguoiDung)) {
        return [];
      }
      return Object.keys(this.danhSachCanBoThemVaoNguoiDung[0])
        .filter(key =>
          ["checkbox", "stt", "hoTen", "userName", "thaoTac" ].includes(key)
        )
        .map(key => {
          return {
            key: key,
            label: BANG_THEM_CAN_BO_VAO_NGUOI_DUNG[key],
            tdClass: ["checkbox", "stt"].includes(key) ? "center" : ""
          };
        });
    },

    layDanhSachCanBoThemVaoNguoiDung(data){
      if (_isEmpty(data)) {
        return [];
      }
      let vm = this;
      let sonth = data && data.items.map((item, index) => {
        return {
          checkbox: null,
          stt: (vm.requestInformation.pageIndex - 1) *
              vm.requestInformation.pageSize +
            index +
            1,
          id: _isNil(item) ? "" : item.id,
          hoTen: _isNil(item) ? "" : item.hoTen,
          userName: _isNil(item) ? "" : item.userName,
          thaoTac: null
        };
      });
      console.log('sonth', sonth);
      return sonth
    }
  }
};
</script>


